import React, { ReactNode, useEffect, useState } from "react";
import { useSpring, animated } from "@react-spring/web";
import { useDrag } from "@use-gesture/react";
import styles from "../styles.module.css";
import { Badge, Card, Box } from "@mui/material";
import Confetti from "react-confetti";

const left = {
  bg: `linear-gradient(120deg, #f093fb 0%, #f5576c 100%)`,
  justifySelf: "end",
};
const right = {
  bg: `linear-gradient(120deg, #96fbc4 0%, #f9f586 100%)`,
  justifySelf: "start",
};

const Slider = ({ children }: { children: ReactNode }) => {
  const [showConfetti, setShowConfetti] = useState(false);
  const [isScaled, setIsScaled] = useState(false);
  const [{ x, bg, scale, justifySelf }, api] = useSpring(() => ({
    x: 0,
    scale: 1,
    ...left,
  }));

  useEffect(() => {
    // Toggle scale periodically every 1.5 seconds
    const intervalId = setInterval(() => {
      setIsScaled((prev) => !prev);
      api.start({
        scale: isScaled ? 1 : 1.1,
      });
    }, 900);

    // Cleanup interval on component unmount
    return () => clearInterval(intervalId);
  }, [isScaled, api]);

  const bind = useDrag(
    ({ active, movement: [mx], direction: [xDir], velocity }) => {
      const triggerConfetti = !active && mx > 0 && Math.abs(mx) > 50; // Trigger confetti on right swipe with significant movement
      if (triggerConfetti) {
        setShowConfetti(true);
        setTimeout(() => setShowConfetti(false), 10000); // Confetti display duration
      }

      api.start({
        x: active ? mx : 0,
        scale: active ? 1.1 : 1,
        ...(mx < 0 ? left : right),
        immediate: (name) => active && name === "x",
      });
    }
  );

  const avSize = x.to({
    map: Math.abs,
    range: [50, 300],
    output: [0.5, 1],
    extrapolate: "clamp",
  });

  return (
    <>
      {showConfetti && <Confetti />}
      <animated.div
        {...bind()}
        className={styles.item}
        style={{ background: bg }}
      >
        <animated.div
          className={styles.av}
          style={{ scale: avSize, justifySelf }}
        />
        <animated.div className={styles.fg} style={{ x, scale }}>
          {children}
        </animated.div>
      </animated.div>
    </>
  );
};

export default function SoftCapDMAI() {
  return (
    <div className={styles.container}>
      <Slider>
        <Badge badgeContent="1" color="primary">
          <Card
            variant="elevation"
            sx={{
              width: "100px", // Explicitly set width to 100px
              height: "100px", // Explicitly set height to 100px
              borderRadius: 3, // Ensure borderRadius matches
              display: "flex", // This ensures the content is centered
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#fff",
            }}
          >
            <Box
              component="img"
              src="softcapdmai3.png"
              alt="SoftCap DealMaker.AI"
              sx={{
                p: 1,
                maxWidth: "80%", // Adjust as needed for the image inside the Card
                maxHeight: "80%",
                width: "auto",
                height: "auto",
              }}
            />
          </Card>
        </Badge>
      </Slider>
    </div>
  );
}
